module.exports = __webpack_public_path__ + "static/media/trezor-logo-h.1da00f60.png";